export const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apl',
  'May',
  'June',
  'July',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const years = [2022, 2021, 2020];
